import "./Request.scss";
import { Fragment } from "react";
import logo from "../../assets/logo/logo.png";

const Request = (prop) => {
  const requests = prop.requests.map((request) => {
    return (
      <div>
        <div className="request">
          <div className="request__container">
            <div className="request__contact">
              <p>
                <span className="request__contact--bold">Selection: </span>
                {request.product}
              </p>
            </div>
            <div className="request__contact">
              <p>
                <span className="request__contact--bold">Name: </span>
                {request.name}
              </p>
              <p>
                <span className="request__contact--bold">Phone Number: </span>{" "}
                {request.phone}
              </p>
            </div>
            <div className="request__contact">
              <p>
                <span className="request__contact--bold">Email Address: </span>
                {request.email}
              </p>
              <p>
                <span className="request__contact--bold">Quantity </span>
                {request.quantity}
              </p>
            </div>
            <div className="request__details">
              <p>
                <span className="request__contact--bold">Pickup Date </span>
                {new Date(request.date).toLocaleDateString()}
              </p>
              <p className="request__extra">
                <span className="request__contact--bold">Extra Details: </span>
                {request.details.split(",").join("\r")}
              </p>
            </div>
          </div>
          <div className="request__img">
            {request.customImage ? (
              <img
                src={request.customImage}
                alt="custom"
                className="request__img"
              />
            ) : (
              <img src={logo} alt="logo" className="request__img" />
            )}
          </div>
        </div>
        <button
          className="request__button"
          onClick={() => prop.handleDelete(request._id)}
        >
          {" "}
          Delete
        </button>
      </div>
    );
  });
  return (
    <Fragment>
      <h1 className="request__title">Requests</h1>
      {requests}
    </Fragment>
  );
};

export default Request;
